export const LAST_BUILD_TIME = '2026-06-10T15:24:09.872Z'